import type { ComponentProps } from 'react';

import { cn } from '../cn';

type ContentSectionProps = Omit<ComponentProps<'div'>, 'size'> & {
  size?: 'small';
};

export const ContentSection = ({ children, size, className, ...props }: ContentSectionProps) => (
  <div
    className={cn(
      'flex w-full flex-col gap-2 overflow-visible max-w-[1200px] [&+&]:mt-16',
      { 'max-w-[760px] [&+&]:mt-10': size === 'small' },
      className,
    )}
    {...props}>
    {children}
  </div>
);

export const ContentSection2 = ({ children, size, className, ...props }: ContentSectionProps) => (
  <div
    className={cn(
      'flex w-full flex-col gap-4 overflow-visible max-w-[1200px] [&+&]:mt-8',
      { 'max-w-[760px] [&+&]:mt-10': size === 'small' },
      className,
    )}
    {...props}>
    {children}
  </div>
);
